<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-one"><div class="section level2" id="appetizers-all-the-young-dudes-cooking-the-foods">
<div class="section level3" id="smashing-pumpkin-and-roasted-red-pepper-soup">
<h3>Smashing Pumpkin and Roasted Red Pepper Soup</h3>
<p style="text-indent:0px;">Got lots of Halloween pumpkins left over? Smash ’em, mash ’em and dash them with caramelized onions. You can always serve up with their hit <em><strong>Butterfly Wings</strong>.</em></p>
<br/><p style="font-weight: bold; text-align: center;"><a class="uri">https://www.youtube.com/watch?v=DF2G7HRQ--w</a></p>
<div class="figure" style="text-align: center;">
<img alt="" src="media/fie5.jpg" style="width:4.92233in;height:3.28125in"/>
<p class="caption">A bowl of soup next to a pumpkin and a bowl of fruit Description automatically generated with low confidence</p>
</div>
<h4 style="text-indent:0px;"><strong>Ingredients</strong></h4>
<p style="text-indent:0px;">2.5 cups pumpkin puree or butternut squash puree.</p>
<p style="text-indent:0px;">1 onion</p>
<p style="text-indent:0px;">2 red bell peppers</p>
<p style="text-indent:0px;">2 Tbsp. olive oil or butter</p>
<p style="text-indent:0px;">1/4 tsp. salt</p>
<p style="text-indent:0px;">1/4 tsp. cumin</p>
<p style="text-indent:0px;">2 leaves sage fresh</p>
<p style="text-indent:0px;">Freshly ground black pepper</p>
<p style="text-indent:0px;">1 crushed clove of garlic</p>
<p style="text-indent:0px;">1 tablespoon of curry powder</p>
<p style="text-indent:0px;"><strong><br/>
</strong></p>
<p style="text-indent:0px;"><strong>Instructions</strong></p>
<br/>
<p style="text-indent:0px;"><strong>1. </strong>Peel and cut the onion in half, and then slice into thin half-moons to get thin ribbons of onions to caramelize.</p>
<p style="text-indent:0px;"><strong>2. </strong>Bake pumpkin slices or squash in the oven at 350degrees F/170°C until they get soft. (Perfect for reusing Halloween pumpkins)</p>
<p style="text-indent:0px;"><strong>3. </strong>Once the flesh is cooked, remove it, and scoop out. Place it in a food processor until it gets smooth.</p>
<p style="text-indent:0px;"><strong>4. </strong>To caramelize the onions, melt the butter in a pan on the stovetop over medium to high heat. Add the onions, breaking them up into thin strips, and sauté them until they brownish shade kicks in. As they tend to stick to the bottom of the pan, add a little water to avoid it as you stir and continue to sauté them. Let them get darker and sweeter. Repeat the process several times until they have reached the level of caramelization that you are happy with.</p>
<p style="text-indent:0px;"><strong>5. </strong>Meanwhile, roast your red peppers until their skins are blackened and peel and de-seed them in cold water. Place them in a blender or food processor until it gets smooth. Then add it to the pureed pumpkin.</p>
<p style="text-indent:0px;"><strong>6. </strong>Remove the caramelized onions from the pan and add to the homemade pumpkin and roasted red pepper puree. If the pumpkin is not well roasted in the oven, or even if you would want to just add a little more flavour, roast it further in the pan on the stove allowing it to caramelize just as you did earlier with the onions. (Not for nearly as long, though)</p>
<p style="text-indent:0px;"><strong>7. </strong>Add the crushed garlic and remaining spices and cook on low heat to suit your taste.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?e3870188